module.exports = __webpack_public_path__ + "img/icon-coffer-silver.16c71018.svg";